import { ForecastTricastSelection, SilkWrapper, TrapWrapper } from "@ppb/the-wall-web";
import { FunctionComponent, useMemo } from "react";
import { RacingSport } from "../../constants";
import { FallbackIconType } from "@ppb/the-wall-common/types";
import { ComponentProps } from "./props";

export const CastRunner: FunctionComponent<ComponentProps> = ({
  horse,
  icon,
  position,
  meetingCountry,
  trap,
  silkFallbackType,
  positionOrdinal,
  racingSport,
  isTrapIconEnabled,
}) => {
  const IconComponent = useMemo(() => {
    if (racingSport === RacingSport.HORSE_RACING) {
      return (
        <SilkWrapper silkUrl={icon as string} silkFallbackType={silkFallbackType as FallbackIconType} silkAlt={horse} />
      );
    }

    if (racingSport === RacingSport.GREYHOUND_RACING && trap && isTrapIconEnabled) {
      return <TrapWrapper region={meetingCountry ?? "AGNOSTIC"} trap={trap} size="small" />;
    }

    return undefined;
  }, [racingSport, trap, isTrapIconEnabled, icon, silkFallbackType, horse, meetingCountry]);

  return (
    <ForecastTricastSelection
      horse={horse}
      icon={IconComponent}
      position={position}
      positionOrdinal={positionOrdinal}
    />
  );
};
